import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OAuthState, OAUTH_FEATURE_KEY } from './oauth.reducer';

const getOAuthState = createFeatureSelector<OAuthState>(OAUTH_FEATURE_KEY);
const getLoading = createSelector(getOAuthState, (state: OAuthState) => state.loading);

export const oauthQuery = {
  getLoading,
};
